/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactToolCallRequestContent } from './ArtifactToolCallRequestContent';
import {
    ArtifactToolCallRequestContentFromJSON,
    ArtifactToolCallRequestContentFromJSONTyped,
    ArtifactToolCallRequestContentToJSON,
    ArtifactToolCallRequestContentToJSONTyped,
} from './ArtifactToolCallRequestContent';

/**
 * 
 * @export
 * @interface ArtifactToolCallRequest
 */
export interface ArtifactToolCallRequest {
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequest
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequest
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequest
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequest
     */
    kind: ArtifactToolCallRequestKindEnum;
    /**
     * 
     * @type {ArtifactToolCallRequestContent}
     * @memberof ArtifactToolCallRequest
     */
    content: ArtifactToolCallRequestContent;
}


/**
 * @export
 */
export const ArtifactToolCallRequestKindEnum = {
    ToolCallRequest: 'tool-call-request'
} as const;
export type ArtifactToolCallRequestKindEnum = typeof ArtifactToolCallRequestKindEnum[keyof typeof ArtifactToolCallRequestKindEnum];


/**
 * Check if a given object implements the ArtifactToolCallRequest interface.
 */
export function instanceOfArtifactToolCallRequest(value: object): value is ArtifactToolCallRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactToolCallRequestFromJSON(json: any): ArtifactToolCallRequest {
    return ArtifactToolCallRequestFromJSONTyped(json, false);
}

export function ArtifactToolCallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactToolCallRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactToolCallRequestContentFromJSON(json['content']),
    };
}

export function ArtifactToolCallRequestToJSON(json: any): ArtifactToolCallRequest {
    return ArtifactToolCallRequestToJSONTyped(json, false);
}

export function ArtifactToolCallRequestToJSONTyped(value?: ArtifactToolCallRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactToolCallRequestContentToJSON(value['content']),
    };
}

